import { useState } from "react";
import { imageDb } from "../../utils/firebase";
import { ref, deleteObject } from "@firebase/storage";
import { useDeleteMediaFileMutation } from "../../hooks/use-delete-media-file-mutation";

export const useDeleteFirebaseImage = () => {
  const [loading, setLoading] = useState(false);
  const { deleteMediaFile } = useDeleteMediaFileMutation();

  const deleteFirebaseImage = async (imagePath: string, imageId: string) => {
    setLoading(true);
    const imageRef = ref(imageDb, imagePath);

    try {
      await deleteObject(imageRef);
      await deleteMediaFile({
        _id: imageId,
      });
    } catch (error) {
      console.error("Error deleting image:", error);
    }
    setLoading(false);
  };

  return {
    deleteFirebaseImage,
    loading,
  };
};